import _typeof from "@babel/runtime/helpers/typeof";
var CATEGORY_DATA = [{
  category: 'Womens Full Body',
  tables: [{
    title: "Women's Full Body",
    id: 'womens-full-body',
    data: {
      columns: [['S/M/L', 'UK', 'EU', 'Bust', 'Waist', 'Hip']],
      rows: [{
        values: [{
          measurement: {
            size: 'XS'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            size: '32'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67'
          }
        }, {
          measurement: {
            inch: '33.5',
            cm: '85'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: '34'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '82'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '69'
          }
        }, {
          measurement: {
            inch: '34.5',
            cm: '88'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'S'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: '36'
          }
        }, {
          measurement: {
            inch: '33.5',
            cm: '85'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: '38'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '89'
          }
        }, {
          measurement: {
            inch: '29.5',
            cm: '75'
          }
        }, {
          measurement: {
            inch: '37.5',
            cm: '95'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: '40'
          }
        }, {
          measurement: {
            inch: '36.5',
            cm: '93'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '99'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          }
        }, {
          measurement: {
            size: '42'
          }
        }, {
          measurement: {
            inch: '38.5',
            cm: '98'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '84'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '16'
          }
        }, {
          measurement: {
            size: '44'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '35.5',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            size: '46'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '97'
          }
        }, {
          measurement: {
            inch: '45.5',
            cm: '116'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '20'
          }
        }, {
          measurement: {
            size: '48'
          }
        }, {
          measurement: {
            inch: '45.5',
            cm: '116'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          }
        }, {
          measurement: {
            size: '50'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }, {
          measurement: {
            inch: '43.5',
            cm: '111'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '24'
          }
        }, {
          measurement: {
            size: '52'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }, {
          measurement: {
            inch: '46.5',
            cm: '118'
          }
        }, {
          measurement: {
            inch: '52.5',
            cm: '134'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '26'
          }
        }, {
          measurement: {
            size: '54'
          }
        }, {
          measurement: {
            inch: '52.5',
            cm: '134'
          }
        }, {
          measurement: {
            inch: '49',
            cm: '125'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }]
      }]
    }
  }, {
    title: 'Inside Leg',
    id: 'inside-leg',
    data: {
      columns: [['', 'Length']],
      rows: [{
        values: [{
          measurement: {
            size: 'SHORT / PETITE'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'REGULAR'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '73'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'LONG'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '78'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: {
      src: '//media.4rgos.it/i/Argos/Womens%20Full%20body2X',
      alt: "Women's Full Body - How to measure your body"
    },
    content: [{
      title: 'Bust',
      description: 'Measure around the fullest part of bust, with tape level at the back.'
    }, {
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Hips',
      description: {
        inch: 'Measure around the fullest part of hip, usually 7.8in down from waist.',
        cm: 'Measure around the fullest part of hip, usually 20cm down from waist.'
      }
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }, {
      title: 'Height',
      description: 'With bare feet together measure from the top of the head to the floor.'
    }]
  },
  petites: {
    title: 'Petites',
    content: [{
      description: "Petite follows the same bust/waist/hip measurements as per the size guide above. However, the differences to the standard women's measurements are as follows.",
      list: [{
        inch: 'The width of the shoulders will reduce by 0.2in',
        cm: 'The width of the shoulders will reduce by 0.5cm'
      }, {
        inch: 'The width of the garment, between the armholes front and back will reduce by 0.4in',
        cm: 'The width of the garment, between the armholes front and back will reduce by 1cm'
      }, {
        inch: 'The circumfrence of the bicep will reduce by 0.4in',
        cm: 'The circumfrence of the bicep will reduce by 1cm'
      }]
    }, {
      description: 'The lengths will reduce as follows:',
      list: [{
        inch: 'Tops will be 1.6in shorter, Tunics will be 2in shorter',
        cm: 'Tops will be 4cm shorter, Tunics will be 5cm shorter'
      }, {
        inch: 'Short dresses will be 2in shorter, above the knee dresses will be 2.2in shorter, knee length dresses will be 2.4in shorter, just below the knee dresses will be 2.6in shorter, mid calf dresses will be 2.8in shorter and maxi dresses will be 3in shorter',
        cm: 'Short dresses will be 5cm shorter, above the knee dresses will be 5.5cm shorter, knee length dresses will be 6cm shorter, just below the knee dresses will be 6.5cm shorter, mid calf dresses will be 7cm shorter and maxi dresses will be 8cm shorter'
      }, {
        inch: 'Short skirts will be 1.2in shorter, above the knee skirts will be 1.4in shorter, knee length skirts will be 1.6in shorter, just below the knee skirts will be 2in shorter, mid calf skirts will be 2in shorter and maxi skirts will be 2.4in shorter',
        cm: 'Short skirts will be 3cm shorter, above the knee skirts will be 3.5cm shorter, knee length skirts will be 4cm shorter, just below the knee skirts will be 4.5cm shorter, mid calf skirts will be 5cm shorter and maxi skirts will be 6cm shorter'
      }, {
        inch: "Short shorts will be 0.4in shorter, medium length shorts will be 0.5in shorter, longer shorts will be 0.8in shorter, capri's, cullottes and crop lengths will be 1.4in shorter, tapered legs and ankle grazers will be 1.8in shorter and full length trousers will be 2in shorter",
        cm: "Short shorts will be 1cm shorter, medium length shorts will be 1.5cm shorter, longer shorts will be 2cm shorter, capri's, cullottes and crop lengths will be 3.5cm shorter, tapered legs and ankle grazers will be 4.5cm shorter and full length trousers will be 5cm shorter"
      }, {
        inch: 'Shorts and trousers will also reduce 0.4in in the rise (area between the waistband and the crotch)',
        cm: 'Shorts and trousers will also reduce 1cm in the rise (area between the waistband and the crotch)'
      }]
    }]
  },
  maternity: {
    title: 'Maternity',
    content: [{
      list: ['Maternity clothing is designed to fit a 9 month bump to ensure garments fit throughout your pregnancy', 'The front lengths are made longer to fit over a growing bump']
    }]
  }
}, {
  category: 'Lingerie',
  tables: [{
    title: "Women's Bras",
    id: 'womens-bras',
    data: {
      columns: [[{
        rowSpan: 2,
        value: 'OVER BUST'
      }, {
        colSpan: 8,
        value: 'UNDER BUST'
      }], [{
        value: {
          inch: '24',
          cm: '61'
        }
      }, {
        value: {
          inch: '26',
          cm: '66'
        }
      }, {
        value: {
          inch: '28',
          cm: '71'
        }
      }, {
        value: {
          inch: '30',
          cm: '76'
        }
      }, {
        value: {
          inch: '32',
          cm: '81'
        }
      }, {
        value: {
          inch: '34',
          cm: '86'
        }
      }, {
        value: {
          inch: '36',
          cm: '91'
        }
      }, {
        value: {
          inch: '38',
          cm: '96'
        }
      }]],
      rows: [{
        values: [{
          measurement: {
            inch: '27',
            cm: '68'
          },
          header: true
        }, {
          measurement: {
            size: '28AA'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '28',
            cm: '71'
          },
          header: true
        }, {
          measurement: {
            size: '28A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '29',
            cm: '74'
          },
          header: true
        }, {
          measurement: {
            size: '28B'
          }
        }, {
          measurement: {
            size: '30AA'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '30',
            cm: '76'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '30A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '31',
            cm: '79'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '30B'
          }
        }, {
          measurement: {
            size: '32AA'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '32',
            cm: '81'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '33',
            cm: '84'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32B'
          }
        }, {
          measurement: {
            size: '34AA'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '34',
            cm: '86'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32C'
          }
        }, {
          measurement: {
            size: '34A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '35',
            cm: '89'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32D'
          }
        }, {
          measurement: {
            size: '34B'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '36',
            cm: '91'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32DD'
          }
        }, {
          measurement: {
            size: '34C'
          }
        }, {
          measurement: {
            size: '36A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '37',
            cm: '94'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32E'
          }
        }, {
          measurement: {
            size: '34D'
          }
        }, {
          measurement: {
            size: '36B'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '38',
            cm: '97'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32F'
          }
        }, {
          measurement: {
            size: '34DD'
          }
        }, {
          measurement: {
            size: '36C'
          }
        }, {
          measurement: {
            size: '38A'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '39',
            cm: '99'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32G'
          }
        }, {
          measurement: {
            size: '34E'
          }
        }, {
          measurement: {
            size: '36D'
          }
        }, {
          measurement: {
            size: '38B'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '40',
            cm: '102'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '32GG'
          }
        }, {
          measurement: {
            size: '34F'
          }
        }, {
          measurement: {
            size: '36DD'
          }
        }, {
          measurement: {
            size: '38C'
          }
        }, {
          measurement: {
            size: '40A'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '41',
            cm: '104'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '34G'
          }
        }, {
          measurement: {
            size: '36E'
          }
        }, {
          measurement: {
            size: '38D'
          }
        }, {
          measurement: {
            size: '40B'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '42',
            cm: '107'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '34GG'
          }
        }, {
          measurement: {
            size: '36F'
          }
        }, {
          measurement: {
            size: '38DD'
          }
        }, {
          measurement: {
            size: '40C'
          }
        }, {
          measurement: {
            size: '42A'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '43',
            cm: '109'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '36G'
          }
        }, {
          measurement: {
            size: '38E'
          }
        }, {
          measurement: {
            size: '40D'
          }
        }, {
          measurement: {
            size: '42B'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '44',
            cm: '112'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '36GG'
          }
        }, {
          measurement: {
            size: '38F'
          }
        }, {
          measurement: {
            size: '40DD'
          }
        }, {
          measurement: {
            size: '42C'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '45',
            cm: '114'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '38G'
          }
        }, {
          measurement: {
            size: '40E'
          }
        }, {
          measurement: {
            size: '42D'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '46',
            cm: '117'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '38GG'
          }
        }, {
          measurement: {
            size: '40F'
          }
        }, {
          measurement: {
            size: '42DD'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '47',
            cm: '119'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '40G'
          }
        }, {
          measurement: {
            size: '42E'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '48',
            cm: '122'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '40GG'
          }
        }, {
          measurement: {
            size: '42F'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '49',
            cm: '124'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '42G'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '50',
            cm: '127'
          },
          header: true
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: '42GG'
          }
        }]
      }]
    }
  }, {
    title: 'International Conversion Chart',
    id: 'international-conversion-chart',
    data: {
      columns: [['', 'A', 'B', 'C', 'D', 'DD']],
      rows: [{
        values: [{
          measurement: {
            size: '30'
          },
          header: true
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '32'
          },
          header: true
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '34'
          },
          header: true
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '36'
          },
          header: true
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '38'
          },
          header: true
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XXL'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '40'
          },
          header: true
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '42'
          },
          header: true
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '44'
          },
          header: true
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }]
    }
  }, {
    title: 'Size Conversion Chart',
    id: 'size-conversion-chart',
    data: {
      columns: [['UK', 'S/M/L', {
        colSpan: 9,
        value: 'CUP SIZE'
      }]],
      rows: [{
        values: [{
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: '30A'
          }
        }, {
          measurement: {
            size: '32A'
          }
        }, {
          measurement: {
            size: '34A'
          }
        }, {
          measurement: {
            size: '30B'
          }
        }, {
          measurement: {
            size: '32B'
          }
        }, {
          measurement: {
            size: '30C'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            size: '30A'
          }
        }, {
          measurement: {
            size: '32A'
          }
        }, {
          measurement: {
            size: '34A'
          }
        }, {
          measurement: {
            size: '30B'
          }
        }, {
          measurement: {
            size: '32B'
          }
        }, {
          measurement: {
            size: '30C'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: '36A'
          }
        }, {
          measurement: {
            size: '38A'
          }
        }, {
          measurement: {
            size: '34B'
          }
        }, {
          measurement: {
            size: '36B'
          }
        }, {
          measurement: {
            size: '32C'
          }
        }, {
          measurement: {
            size: '34C'
          }
        }, {
          measurement: {
            size: '30D'
          }
        }, {
          measurement: {
            size: '32D'
          }
        }, {
          measurement: {
            size: '30DD'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: '36A'
          }
        }, {
          measurement: {
            size: '38A'
          }
        }, {
          measurement: {
            size: '34B'
          }
        }, {
          measurement: {
            size: '36B'
          }
        }, {
          measurement: {
            size: '32C'
          }
        }, {
          measurement: {
            size: '34C'
          }
        }, {
          measurement: {
            size: '30D'
          }
        }, {
          measurement: {
            size: '32D'
          }
        }, {
          measurement: {
            size: '30DD'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: '40A'
          }
        }, {
          measurement: {
            size: '38B'
          }
        }, {
          measurement: {
            size: '36C'
          }
        }, {
          measurement: {
            size: '34D'
          }
        }, {
          measurement: {
            size: '32DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: '40A'
          }
        }, {
          measurement: {
            size: '38B'
          }
        }, {
          measurement: {
            size: '36C'
          }
        }, {
          measurement: {
            size: '34D'
          }
        }, {
          measurement: {
            size: '32DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '16'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: '42A'
          }
        }, {
          measurement: {
            size: '40B'
          }
        }, {
          measurement: {
            size: '38C'
          }
        }, {
          measurement: {
            size: '36D'
          }
        }, {
          measurement: {
            size: '34DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: '42A'
          }
        }, {
          measurement: {
            size: '40B'
          }
        }, {
          measurement: {
            size: '38C'
          }
        }, {
          measurement: {
            size: '36D'
          }
        }, {
          measurement: {
            size: '34DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '20'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: '44A'
          }
        }, {
          measurement: {
            size: '42B'
          }
        }, {
          measurement: {
            size: '40C'
          }
        }, {
          measurement: {
            size: '38D'
          }
        }, {
          measurement: {
            size: '36DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: '44A'
          }
        }, {
          measurement: {
            size: '42B'
          }
        }, {
          measurement: {
            size: '40C'
          }
        }, {
          measurement: {
            size: '38D'
          }
        }, {
          measurement: {
            size: '36DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '24'
          }
        }, {
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            size: '44B'
          }
        }, {
          measurement: {
            size: '42C'
          }
        }, {
          measurement: {
            size: '40D'
          }
        }, {
          measurement: {
            size: '38DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '26'
          }
        }, {
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            size: '44C'
          }
        }, {
          measurement: {
            size: '42D'
          }
        }, {
          measurement: {
            size: '44D'
          }
        }, {
          measurement: {
            size: '40DD'
          }
        }, {
          measurement: {
            size: '42DD'
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }]
    }
  }, {
    title: 'Knickers, Crop Tops, Camis & Slips',
    id: 'knickers-crop-tops-camis-&-slips',
    data: {
      columns: [['S/M/L', 'UK', 'EU', 'Bust', 'Waist', 'Hip']],
      rows: [{
        values: [{
          measurement: {
            size: 'XS'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            size: '32'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67'
          }
        }, {
          measurement: {
            inch: '33.5',
            cm: '85'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: '34'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '82'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '69'
          }
        }, {
          measurement: {
            inch: '34.5',
            cm: '88'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'S'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: '36'
          }
        }, {
          measurement: {
            inch: '33.5',
            cm: '85'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: '38'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '89'
          }
        }, {
          measurement: {
            inch: '29.5',
            cm: '75'
          }
        }, {
          measurement: {
            inch: '37.5',
            cm: '95'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: '40'
          }
        }, {
          measurement: {
            inch: '36.5',
            cm: '93'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '99'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          }
        }, {
          measurement: {
            size: '42'
          }
        }, {
          measurement: {
            inch: '38.5',
            cm: '98'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '84'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '16'
          }
        }, {
          measurement: {
            size: '44'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '35.5',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            size: '46'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '97'
          }
        }, {
          measurement: {
            inch: '45.5',
            cm: '116'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '20'
          }
        }, {
          measurement: {
            size: '48'
          }
        }, {
          measurement: {
            inch: '45.5',
            cm: '116'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          }
        }, {
          measurement: {
            size: '50'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }, {
          measurement: {
            inch: '43.5',
            cm: '111'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '24'
          }
        }, {
          measurement: {
            size: '52'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }, {
          measurement: {
            inch: '46.5',
            cm: '118'
          }
        }, {
          measurement: {
            inch: '52.5',
            cm: '134'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '26'
          }
        }, {
          measurement: {
            size: '54'
          }
        }, {
          measurement: {
            inch: '52.5',
            cm: '134'
          }
        }, {
          measurement: {
            inch: '49',
            cm: '125'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            size: '28'
          }
        }, {
          measurement: {
            size: '56'
          }
        }, {
          measurement: {
            inch: '54.5',
            cm: '138'
          }
        }, {
          measurement: {
            inch: '51',
            cm: '132'
          }
        }, {
          measurement: {
            inch: '57',
            cm: '146'
          }
        }]
      }]
    }
  }, {
    title: 'Tights',
    id: 'tights',
    data: {
      columns: [[{
        value: 'UK',
        rowSpan: 2
      }, {
        value: 'Height',
        colSpan: 3
      }], [{
        value: {
          inch: "5' - 5'4\"",
          cm: '153 - 163'
        }
      }, {
        value: {
          inch: '5\'5" - 5\'8"',
          cm: '165 - 173'
        }
      }, {
        value: {
          inch: "5'9\" - 6'",
          cm: '175 - 183'
        }
      }]],
      rows: [{
        values: [{
          measurement: {
            size: '8'
          },
          header: true
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          },
          header: true
        }, {
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12'
          },
          header: true
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          },
          header: true
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '16'
          },
          header: true
        }, {
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          },
          header: true
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '20'
          },
          header: true
        }, {
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          },
          header: true
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '24'
          },
          header: true
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: {
      src: '//media.4rgos.it/i/Argos/Womens%20Lingerie2X',
      alt: 'Lingerie - How to measure your body'
    },
    content: [{
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Hips',
      description: {
        inch: 'Measure around the fullest part of hip, usually 7.8in down from waist.',
        cm: 'Measure around the fullest part of hip, usually 20cm down from waist.'
      }
    }, {
      title: 'Height',
      description: 'With bare feet together measure from the top of the head to the floor.'
    }]
  },
  instructions: {
    title: 'Stand up right with a non-padded bra on',
    content: [{
      description: 'Band Size',
      list: ['Take a firm measurement, under bust in inches (this is your first band size measurement).', 'If this measurement is an even number add 4 inches, if it is odd add 5 inches. This number is your band size.']
    }, {
      description: 'Cup Size',
      list: ['Take a loose measurement with the tape measure sitting at the lowest point of your shoulder blade at the back and at the fullest part of your bust at the front.', "The difference between the first band size measurement, and the cup size measurement will determine your cup size;\n                4\"-AA, 5\"-A, 6\"-B, 7\"-C, 8\"-D, 9\"-DD, 10\"-E, 11\"-F, 12\"-FF, 13\"-G, 14\"-GG, 15\"-H, 16\"-HH, 17\"-J, 18\"-JJ, 19\"-K"]
    }, {
      description: 'Example:'
    }, {
      description: 'Band Size',
      list: ['Under bust measurement = 29 inches', 'Add 5 inches = 34 inches']
    }, {
      description: 'Cup size',
      list: ['Fullest part of the burst measurement = 38 inches', 'Difference between 29 inches and 38 inches is 9 = DD cup']
    }, {
      description: 'Bra size is 34DD'
    }]
  }
}, {
  category: 'Womens Trousers & Jeans',
  tables: [{
    title: "Women's Trousers & Jeans",
    id: 'womens-trousers-and-jeans',
    data: {
      columns: [['S/M/L', 'UK', 'EU', 'Waist', 'Hip']],
      rows: [{
        values: [{
          measurement: {
            size: 'XS'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            size: '32'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '85'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: '34'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '69'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '88'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'S'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: '36'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: '38'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '75'
          }
        }, {
          measurement: {
            inch: '37',
            cm: '95'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: '40'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '99'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          }
        }, {
          measurement: {
            size: '42'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '84'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '16'
          }
        }, {
          measurement: {
            size: '44'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            size: '46'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '97'
          }
        }, {
          measurement: {
            inch: '45',
            cm: '116'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '20'
          }
        }, {
          measurement: {
            size: '48'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          }
        }, {
          measurement: {
            size: '50'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '111'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '24'
          }
        }, {
          measurement: {
            size: '52'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '118'
          }
        }, {
          measurement: {
            inch: '52',
            cm: '134'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '26'
          }
        }, {
          measurement: {
            size: '54'
          }
        }, {
          measurement: {
            inch: '49',
            cm: '125'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }]
      }]
    }
  }, {
    title: 'Inside Leg',
    id: 'inside-leg',
    data: {
      columns: [['', 'Length']],
      rows: [{
        values: [{
          measurement: {
            size: 'SHORT'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'REGULAR'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '72'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'LONG'
          }
        }, {
          measurement: {
            inch: '30',
            cm: '77'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: {
      src: '//media.4rgos.it/i/Argos/Womens%20Full%20Jeans2X',
      alt: "Women's Trousers & Jeans - How to measure your body"
    },
    content: [{
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Hips',
      description: {
        inch: 'Measure around the fullest part of hip, usually 7.8in down from waist.',
        cm: 'Measure around the fullest part of hip, usually 20cm down from waist.'
      }
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }]
  },
  tall: {
    title: 'Tall',
    content: [{
      description: "Tall follows the same bust/waist/hip measurements as per the size guide above. However, the differences to the standard women's measurements are as follows.",
      list: [{
        inch: "Short shorts will be 0.4in taller, medium length shorts will be 0.5in taller, longer shorts will be 0.8in taller, capri's, cullottes and crop lengths will be 1.4in taller, tapered legs and ankle grazers will be 1.8in taller and full length trousers will be 2in taller",
        cm: "Short shorts will be 1cm taller, medium length shorts will be 1.5cm taller, longer shorts will be 2cm taller, capri's, cullottes and crop lengths will be 3.5cm taller, tapered legs and ankle grazers will be 4.5cm taller and full length trousers will be 5cm taller"
      }, {
        inch: 'Shorts and trousers will also increase 0.4in in the rise (area between the waistband and the crotch)',
        cm: 'Shorts and trousers will also increase 1cm in the rise (area between the waistband and the crotch)'
      }]
    }]
  },
  maternity: {
    title: 'Maternity',
    content: [{
      list: ['Maternity clothing is designed to fit a 9 month bump to ensure garments fit throughout your pregnancy']
    }]
  }
}, {
  category: 'Womens Footwear & Accessories',
  tables: [{
    title: "Women's Footwear & Slippers",
    id: 'womens-footwear-and-slippers',
    data: {
      columns: [['S/M/L', 'UK', 'EU']],
      rows: [{
        values: [{
          measurement: {
            size: 'S'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '3'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            inch: '37',
            cm: '94'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '5'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '97'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '99'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '7'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            inch: '42',
            cm: '107'
          }
        }]
      }]
    }
  }, {
    title: 'Accessories',
    id: 'belts',
    unitToggle: false,
    data: {
      columns: [[{
        colSpan: 2,
        value: 'Belts'
      }], ['S/M/L', 'UK']],
      rows: [{
        values: [{
          measurement: {
            size: 'S'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '8'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '12'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '16'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          },
          rowSpan: 2
        }, {
          measurement: {
            size: '20'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '22'
          }
        }]
      }]
    }
  }]
}, {
  category: 'Mens Full Body',
  tables: [{
    title: "Men's Full Body",
    id: 'mens-full-body',
    data: {
      columns: [['Alpha Size', 'Chest', 'Waist']],
      rows: [{
        values: [{
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            inch: '30-32',
            cm: '77-82'
          }
        }, {
          measurement: {
            inch: '27-29',
            cm: '69-74'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            inch: '34-36',
            cm: '87-92'
          }
        }, {
          measurement: {
            inch: '30-32',
            cm: '76-81'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            inch: '38-40',
            cm: '97-102'
          }
        }, {
          measurement: {
            inch: '33-35',
            cm: '84-89'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            inch: '42-44',
            cm: '107-112'
          }
        }, {
          measurement: {
            inch: '36-38',
            cm: '91-97'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            inch: '46-48',
            cm: '117-122'
          }
        }, {
          measurement: {
            inch: '39-41',
            cm: '99-104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            inch: '50-52',
            cm: '127-132'
          }
        }, {
          measurement: {
            inch: '42-44',
            cm: '107-112'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            inch: '54-56',
            cm: '137-142'
          }
        }, {
          measurement: {
            inch: '45-49',
            cm: '115-120'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXXXL'
          }
        }, {
          measurement: {
            inch: '58-60',
            cm: '147-152'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }]
      }]
    }
  }, {
    title: 'Shirts',
    id: 'shirts',
    data: {
      columns: [['Collar', 'Chest', 'Sleeve Length']],
      rows: [{
        values: [{
          measurement: {
            inch: '14',
            cm: '36'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '86.5'
          }
        }, {
          measurement: {
            inch: '25.6',
            cm: '65.2'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '14.5',
            cm: '37'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91.5'
          }
        }, {
          measurement: {
            inch: '25.9',
            cm: '65.8'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '15',
            cm: '38'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '96.5'
          }
        }, {
          measurement: {
            inch: '26.1',
            cm: '66.4'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '15.5',
            cm: '39'
          }
        }, {
          measurement: {
            inch: '40',
            cm: '101.5'
          }
        }, {
          measurement: {
            inch: '26.3',
            cm: '67'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '16',
            cm: '41'
          }
        }, {
          measurement: {
            inch: '42',
            cm: '106.5'
          }
        }, {
          measurement: {
            inch: '26.6',
            cm: '67.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '16.5',
            cm: '42'
          }
        }, {
          measurement: {
            inch: '44',
            cm: '112'
          }
        }, {
          measurement: {
            inch: '26.8',
            cm: '68'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '17',
            cm: '43'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '117'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '17.5',
            cm: '44.5'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }, {
          measurement: {
            inch: '27.15',
            cm: '69'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '18',
            cm: '46'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '127'
          }
        }, {
          measurement: {
            inch: '27.3',
            cm: '69.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '18.5',
            cm: '47'
          }
        }, {
          measurement: {
            inch: '52',
            cm: '132'
          }
        }, {
          measurement: {
            inch: '27.5',
            cm: '70'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '19',
            cm: '48'
          }
        }, {
          measurement: {
            inch: '54',
            cm: '137'
          }
        }, {
          measurement: {
            inch: '27.7',
            cm: '70.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '56',
            cm: '142'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '20',
            cm: '52'
          }
        }, {
          measurement: {
            inch: '58',
            cm: '147'
          }
        }, {
          measurement: {
            inch: '28.15',
            cm: '71.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '20.5',
            cm: '54'
          }
        }, {
          measurement: {
            inch: '60',
            cm: '152'
          }
        }, {
          measurement: {
            inch: '28.3',
            cm: '72'
          }
        }]
      }, {
        values: [{
          measurement: {
            inch: '21',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '62',
            cm: '157'
          }
        }, {
          measurement: {
            inch: '28.5',
            cm: '72.5'
          }
        }]
      }]
    }
  }, {
    title: 'Inside Leg',
    id: 'inside-leg',
    data: {
      columns: [['', 'Length']],
      rows: [{
        values: [{
          measurement: {
            size: 'Short'
          }
        }, {
          measurement: {
            inch: '29-30',
            cm: '74-76'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Regular'
          }
        }, {
          measurement: {
            inch: '31-32',
            cm: '79-81'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Long'
          }
        }, {
          measurement: {
            inch: '33-34',
            cm: '84-86'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Extra long'
          }
        }, {
          measurement: {
            inch: '35-36',
            cm: '89-91'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: {
      src: '//media.4rgos.it/i/Argos/Mens%20Full%20body2X',
      alt: "Men's Full Body - How to measure your body"
    },
    content: [{
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Collar',
      description: 'Measure around the centre of the neck.'
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }]
  }
}, {
  category: 'Mens Trousers & Jeans',
  tables: [{
    title: "Men's Trousers & Jeans",
    id: 'mens-trousers-and-jeans',
    data: {
      columns: [['Alpha Size', 'Waist']],
      rows: [{
        values: [{
          measurement: {
            size: 'XS'
          }
        }, {
          measurement: {
            inch: '27-29',
            cm: '69-74'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            inch: '30-32',
            cm: '76-81'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            inch: '33-35',
            cm: '84-89'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            inch: '36-38',
            cm: '91-97'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            inch: '39-41',
            cm: '99-104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            inch: '42-44',
            cm: '107-112'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXXL'
          }
        }, {
          measurement: {
            inch: '45-49',
            cm: '115-120'
          }
        }]
      }]
    }
  }, {
    title: 'Inside Leg',
    id: 'inside-leg',
    data: {
      columns: [['', 'Length']],
      rows: [{
        values: [{
          measurement: {
            size: 'Short'
          }
        }, {
          measurement: {
            inch: '28-29',
            cm: '71-74'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Regular'
          }
        }, {
          measurement: {
            inch: '30-31',
            cm: '76-79'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Long'
          }
        }, {
          measurement: {
            inch: '32-33',
            cm: '81-84'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Extra long'
          }
        }, {
          measurement: {
            inch: '34-35',
            cm: '86-89'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: {
      src: '//media.4rgos.it/i/Argos/Mens%20Full%20Jeans2X',
      alt: "Men's Trousers & Jeans - How to measure your body"
    },
    content: [{
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }]
  }
}, {
  category: 'Mens Footwear & Accessories',
  tables: [{
    title: "Men's Footwear & Slippers",
    id: 'mens-footwear-and-slippers',
    data: {
      columns: [['UK Size', 'EU Size']],
      rows: [{
        values: [{
          measurement: {
            size: '5'
          }
        }, {
          measurement: {
            size: '38'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: '39'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '7'
          }
        }, {
          measurement: {
            size: '41'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: '42'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9'
          }
        }, {
          measurement: {
            size: '43'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: '44'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '11'
          }
        }, {
          measurement: {
            size: '45'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: '46'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Small (7/8)'
          }
        }, {
          measurement: {
            size: '41/42'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Medium (9/10)'
          }
        }, {
          measurement: {
            size: '43/44'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Large (11/12)'
          }
        }, {
          measurement: {
            size: '45/46'
          }
        }]
      }]
    }
  }, {
    title: "Men's Accessories",
    id: 'hats',
    data: {
      columns: [[{
        colSpan: 2,
        value: 'Hats'
      }], ['S/M', 'L/XL']],
      rows: [{
        values: [{
          measurement: {
            inch: '23',
            cm: '58'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '60'
          }
        }]
      }]
    }
  }, {
    title: '',
    id: 'belts',
    unitToggle: false,
    data: {
      columns: [[{
        colSpan: 2,
        value: 'Belts'
      }], ['S/M/L', 'UK']],
      rows: [{
        values: [{
          measurement: {
            size: 'S'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '81'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'M'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '89'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'L'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '96'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XL'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'XXL'
          }
        }, {
          measurement: {
            inch: '44',
            cm: '112'
          }
        }]
      }]
    }
  }]
}, {
  category: 'Kids & Toddler Full Body',
  tables: [{
    title: '9 months - 7 years',
    description: 'All Kids Clothing & Schoolwear',
    id: 'kids-full-body-9mnths-7yrs',
    data: {
      columns: [['Size', 'Dual Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '9-12mths'
          }
        }, {
          measurement: {
            size: '9-12 mths'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '80'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '19.25',
            cm: '48.5'
          }
        }, {
          measurement: {
            inch: '19.75',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '12',
            cm: '32'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12-18mths/1yr-1.5yrs'
          }
        }, {
          measurement: {
            size: '12-18 mths/1-1.5 yrs'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '86'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '51'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '20.25',
            cm: '51.5'
          }
        }, {
          measurement: {
            inch: '14',
            cm: '35'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18mths-2yrs/1.5yrs-2yrs'
          }
        }, {
          measurement: {
            size: '18-24 mths/1.5-2 yrs'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '92'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '19.75',
            cm: '50.5'
          }
        }, {
          measurement: {
            inch: '20.75',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '15',
            cm: '38.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3 yrs'
          }
        }, {
          measurement: {
            size: '2-3 yrs'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '99'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '17',
            cm: '43'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '4 yrs'
          }
        }, {
          measurement: {
            size: '3-4 yrs'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '61'
          }
        }, {
          measurement: {
            inch: '18',
            cm: '46'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '5 yrs'
          }
        }, {
          measurement: {
            size: '4-5 yrs'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '109'
          }
        }, {
          measurement: {
            inch: '23',
            cm: '58'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '61'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '51'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6 yrs'
          }
        }, {
          measurement: {
            size: '5-6 yrs'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '117'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '61'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '51'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '7 yrs'
          }
        }, {
          measurement: {
            size: '6-7 yrs'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '66'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }]
      }]
    }
  }, {
    title: '8 years - 18 years',
    description: 'Girls Clothing & Schoolwear',
    id: 'kids-full-body-8-18yrs-girls',
    data: {
      columns: [['Size', 'Dual Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '8 yrs'
          }
        }, {
          measurement: {
            size: '7-8 yrs'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '23',
            cm: '58'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '70'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '60'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9 yrs'
          }
        }, {
          measurement: {
            size: '8-9 yrs'
          }
        }, {
          measurement: {
            inch: '53',
            cm: '134'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67'
          }
        }, {
          measurement: {
            inch: '23.5',
            cm: '59.5'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '73.5'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '63'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10 yrs'
          }
        }, {
          measurement: {
            size: '9-10 yrs'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71.5'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '61.5'
          }
        }, {
          measurement: {
            inch: '30',
            cm: '77'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '66'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '11 yrs'
          }
        }, {
          measurement: {
            size: '10-11 yrs'
          }
        }, {
          measurement: {
            inch: '57',
            cm: '146'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74.5'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '63'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '80.5'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12 yrs'
          }
        }, {
          measurement: {
            size: '11-12 yrs'
          }
        }, {
          measurement: {
            inch: '60',
            cm: '152'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '78'
          }
        }, {
          measurement: {
            inch: '25.5',
            cm: '65'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '84'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '13 yrs'
          }
        }, {
          measurement: {
            size: '12-13 yrs'
          }
        }, {
          measurement: {
            inch: '62',
            cm: '158'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '80'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '66'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '86'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14 yrs'
          }
        }, {
          measurement: {
            size: '13-14 yrs'
          }
        }, {
          measurement: {
            inch: '64.5',
            cm: '164'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '82.5'
          }
        }, {
          measurement: {
            inch: '26.5',
            cm: '67.5'
          }
        }, {
          measurement: {
            inch: '34.5',
            cm: '88'
          }
        }, {
          measurement: {
            inch: '30.5',
            cm: '77.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '15 yrs'
          }
        }, {
          measurement: {
            size: '14-15 yrs'
          }
        }, {
          measurement: {
            inch: '65',
            cm: '166'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '84.5'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68.5'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '78.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '16 yrs'
          }
        }, {
          measurement: {
            size: '15-16 yrs'
          }
        }, {
          measurement: {
            inch: '65',
            cm: '166'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '87'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '69'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '92'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '78.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '17 yrs'
          }
        }, {
          measurement: {
            size: '16-17 yrs'
          }
        }, {
          measurement: {
            inch: '67',
            cm: '170'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '88.5'
          }
        }, {
          measurement: {
            inch: '27.5',
            cm: '70'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18 yrs'
          }
        }, {
          measurement: {
            size: '17-18 yrs'
          }
        }, {
          measurement: {
            inch: '69',
            cm: '176'
          }
        }, {
          measurement: {
            inch: '35.5',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }]
      }]
    }
  }, {
    title: '',
    description: 'Boys Clothing, Boys Schoolwear & Unisex Schoolwear',
    id: 'kids-full-body-8-18yrs-boys',
    data: {
      columns: [['Size', 'Dual Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '8 yrs'
          }
        }, {
          measurement: {
            size: '7-8 yrs'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '23',
            cm: '59'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68'
          }
        }, {
          measurement: {
            inch: '23',
            cm: '59'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9 yrs'
          }
        }, {
          measurement: {
            size: '8-9 yrs'
          }
        }, {
          measurement: {
            inch: '53',
            cm: '134'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '67.5'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '61'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '24.5',
            cm: '62.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10 yrs'
          }
        }, {
          measurement: {
            size: '9-10 yrs'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '63.5'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74'
          }
        }, {
          measurement: {
            inch: '25.5',
            cm: '65'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '11 yrs'
          }
        }, {
          measurement: {
            size: '10-11 yrs'
          }
        }, {
          measurement: {
            inch: '57',
            cm: '146'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74.5'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '65.5'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '77.5'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12 yrs'
          }
        }, {
          measurement: {
            size: '11-12 yrs'
          }
        }, {
          measurement: {
            inch: '60',
            cm: '152'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '78'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '81'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '70.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '13 yrs'
          }
        }, {
          measurement: {
            size: '12-13 yrs'
          }
        }, {
          measurement: {
            inch: '62',
            cm: '158'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '83.5'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '70'
          }
        }, {
          measurement: {
            inch: '33',
            cm: '85'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '73'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14 yrs'
          }
        }, {
          measurement: {
            size: '13-14 yrs'
          }
        }, {
          measurement: {
            inch: '64.5',
            cm: '164'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '86'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '73'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '89'
          }
        }, {
          measurement: {
            inch: '30',
            cm: '76'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '15 yrs'
          }
        }, {
          measurement: {
            size: '14-15 yrs'
          }
        }, {
          measurement: {
            inch: '67',
            cm: '170'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '88.5'
          }
        }, {
          measurement: {
            inch: '30',
            cm: '74.5'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91.5'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '79'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '16 yrs'
          }
        }, {
          measurement: {
            size: '15-16 yrs'
          }
        }, {
          measurement: {
            inch: '69',
            cm: '176'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '91.5'
          }
        }, {
          measurement: {
            inch: '30',
            cm: '76'
          }
        }, {
          measurement: {
            inch: '37',
            cm: '94'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '82'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '17 yrs'
          }
        }, {
          measurement: {
            size: '16-17 yrs'
          }
        }, {
          measurement: {
            inch: '70',
            cm: '178'
          }
        }, {
          measurement: {
            inch: '38',
            cm: '97'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '82'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18 yrs'
          }
        }, {
          measurement: {
            size: '17-18 yrs'
          }
        }, {
          measurement: {
            inch: '71',
            cm: '180'
          }
        }, {
          measurement: {
            inch: '40',
            cm: '102'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '88'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }]
      }]
    }
  }, {
    title: 'Fancy Dress Costumes',
    id: 'fancy-dress-costumes ',
    data: {
      columns: [['Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '6-9mths'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74'
          }
        }, {
          measurement: {
            inch: '18.5',
            cm: '47'
          }
        }, {
          measurement: {
            inch: '18.5',
            cm: '46.5'
          }
        }, {
          measurement: {
            inch: '18.75',
            cm: '48'
          }
        }, {
          measurement: {
            inch: '11.5',
            cm: '29'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9-12mths'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '80'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '19',
            cm: '48.5'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '12.5',
            cm: '32'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '1-2yrs'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '92'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '19.75',
            cm: '50.5'
          }
        }, {
          measurement: {
            inch: '20.75',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '15',
            cm: '38.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '2-3yrs'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '98'
          }
        }, {
          measurement: {
            inch: '21.5',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '16.75',
            cm: '42.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-4 yrs'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '21.5',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '23.5',
            cm: '60'
          }
        }, {
          measurement: {
            inch: '18',
            cm: '45.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '5-6 yrs'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '116'
          }
        }, {
          measurement: {
            inch: '23.75',
            cm: '60.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '7-8yrs'
          }
        }, {
          measurement: {
            inch: '50',
            cm: '128'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '23.35',
            cm: '59'
          }
        }, {
          measurement: {
            inch: '26.75',
            cm: '68'
          }
        }, {
          measurement: {
            inch: '23.25',
            cm: '59'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9-10yrs'
          }
        }, {
          measurement: {
            inch: '55',
            cm: '140'
          }
        }, {
          measurement: {
            inch: '28',
            cm: '71'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '63.5'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74'
          }
        }, {
          measurement: {
            inch: '25.5',
            cm: '65'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '11-12yrs'
          }
        }, {
          measurement: {
            inch: '60',
            cm: '152'
          }
        }, {
          measurement: {
            inch: '30.75',
            cm: '78'
          }
        }, {
          measurement: {
            inch: '26.75',
            cm: '68'
          }
        }, {
          measurement: {
            inch: '32',
            cm: '81'
          }
        }, {
          measurement: {
            inch: '27.75',
            cm: '70.5'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: null,
    content: [{
      title: 'Chest',
      description: 'Measure at the fullest part of the chest, under the armpits keeping the tape measure level.'
    }, {
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Hips',
      description: {
        inch: 'Measure around the fullest part of hip, usually 7.8in down from waist.',
        cm: 'Measure around the fullest part of hip, usually 20cm down from waist.'
      }
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }]
  },
  boyswear: {
    title: 'Boyswear',
    content: [{
      list: [{
        inch: 'Plus fit- +1.2inches more generous on the chest and waist girth and +1.6inches more generous on the hip girth compared to our regular fit.',
        cm: 'Plus fit- +3cm more generous on the chest and waist girth and +4cm more generous on the hip girth compared to our regular fit.'
      }, {
        inch: 'Longer length is +1.6inches longer than our regular fit.',
        cm: 'Longer length is +4cm longer than our regular fit.'
      }, {
        inch: 'Slim Fit - narrower through the body by 1.9inches from the regular fit.',
        cm: 'Slim Fit - narrower through the body by 5cm from the regular fit.'
      }]
    }]
  },
  girlswear: {
    title: 'Girlswear',
    content: [{
      list: [{
        inch: 'Plus fit- +1.2inches more generous on the chest girth and +1.6inches more generous on the waist and hip girth compared to our regular fit.',
        cm: 'Plus fit- +3cm more generous on the chest girth and +4cm more generous on the waist and hip girth compared to our regular fit.'
      }, {
        inch: 'Longer length is +1.6inches longer than our regular fit.',
        cm: 'Longer length is +4cm longer than our regular fit.'
      }, {
        inch: 'Slim Fit - narrower through the body by 1.9inches from the regular fit.',
        cm: 'Slim Fit - narrower through the body by 5cm from the regular fit.'
      }]
    }]
  }
}, {
  category: 'Baby & Toddler',
  tables: [{
    title: 'Premature - 2yrs',
    id: 'baby-and-toddler-premature-2yrs',
    data: {
      columns: [['Size', 'Height', 'Weight']],
      rows: [{
        values: [{
          measurement: {
            size: 'Premature'
          }
        }, {
          measurement: {
            inch: '',
            cm: ''
          }
        }, {
          measurement: {
            size: '2lbs-4lbs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Tiny Baby'
          }
        }, {
          measurement: {
            inch: '17',
            cm: '44'
          }
        }, {
          measurement: {
            size: '5lb'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Newborn'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '50'
          }
        }, {
          measurement: {
            size: '7lb'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Up to 1 mth'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            size: 'up to 10 lbs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '0-3 mths'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '62'
          }
        }, {
          measurement: {
            size: 'up to 14lbs '
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-6 mths'
          }
        }, {
          measurement: {
            inch: '27',
            cm: '68'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6-9 mths'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9-12 mths'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '80'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12-18 mths/1-1.5 yrs'
          }
        }, {
          measurement: {
            inch: '34',
            cm: '86'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18 mths-2 yrs/1.5-2 yrs'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '92'
          }
        }, {
          measurement: {
            size: ''
          }
        }]
      }]
    }
  }, {
    title: '3yrs - 7yrs',
    description: 'Regular',
    id: 'baby-and-toddler-3yrs-7yrs',
    data: {
      columns: [['Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '3 yrs'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '98'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '17',
            cm: '42.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '4 yrs'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '60'
          }
        }, {
          measurement: {
            inch: '18',
            cm: '45.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '5 yrs'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }, {
          measurement: {
            inch: '23',
            cm: '58'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '55'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '62'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '50'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6 yrs'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '116'
          }
        }, {
          measurement: {
            inch: '24',
            cm: '60.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '52'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '7 yrs'
          }
        }, {
          measurement: {
            inch: '48',
            cm: '122'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '63'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '57'
          }
        }, {
          measurement: {
            inch: '26',
            cm: '66'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }]
      }]
    }
  }, {
    title: 'Dress Up - 6-9mths to 5-6yrs',
    id: 'baby-and-toddler-dress-up-6-9mths-to-5-6yrs',
    data: {
      columns: [['Size', 'Height', 'Chest', 'Waist', 'Hip', 'Inside Leg']],
      rows: [{
        values: [{
          measurement: {
            size: '6-9 mths'
          }
        }, {
          measurement: {
            inch: '29',
            cm: '74'
          }
        }, {
          measurement: {
            inch: '18.5',
            cm: '47'
          }
        }, {
          measurement: {
            inch: '18.5',
            cm: '46.5'
          }
        }, {
          measurement: {
            inch: '18.75',
            cm: '48'
          }
        }, {
          measurement: {
            inch: '11.5',
            cm: '29'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9-12 mths'
          }
        }, {
          measurement: {
            inch: '31',
            cm: '80'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '19',
            cm: '48.5'
          }
        }, {
          measurement: {
            inch: '19.5',
            cm: '50'
          }
        }, {
          measurement: {
            inch: '12.5',
            cm: '32'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '1-2 yrs'
          }
        }, {
          measurement: {
            inch: '36',
            cm: '92'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '19.75',
            cm: '50.5'
          }
        }, {
          measurement: {
            inch: '20.75',
            cm: '53'
          }
        }, {
          measurement: {
            inch: '15',
            cm: '38.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '2-3 yrs'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '98'
          }
        }, {
          measurement: {
            inch: '21.5',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '16.75',
            cm: '42.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-4 yrs'
          }
        }, {
          measurement: {
            inch: '41',
            cm: '104'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '21.5',
            cm: '54.5'
          }
        }, {
          measurement: {
            inch: '23.5',
            cm: '60'
          }
        }, {
          measurement: {
            inch: '18',
            cm: '45.5'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '5-6 yrs'
          }
        }, {
          measurement: {
            inch: '46',
            cm: '116'
          }
        }, {
          measurement: {
            inch: '23.75',
            cm: '60.5'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }, {
          measurement: {
            inch: '25',
            cm: '64'
          }
        }, {
          measurement: {
            inch: '20.5',
            cm: '52'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: null,
    content: [{
      title: 'Chest',
      description: 'Measure at the fullest part of the chest, under the armpits keeping the tape measure level.'
    }, {
      title: 'Waist',
      description: 'Measure around the natural waist with tape measure taut.'
    }, {
      title: 'Hips',
      description: {
        inch: 'Measure around the fullest part of hip, usually 7.8in down from waist.',
        cm: 'Measure around the fullest part of hip, usually 20cm down from waist.'
      }
    }, {
      title: 'Inside leg',
      description: 'Measure from the crotch to bottom of ankle bone.'
    }]
  }
}, {
  category: 'Kids & Baby Footwear & Accessories',
  tables: [{
    title: "Baby & Kids' Footwear",
    id: 'baby-&-kids-footwear',
    data: {
      columns: [['UK Size', 'European Size', {
        value: {
          inch: 'Foot length (inches)',
          cm: 'Foot length (mm)'
        }
      }, 'Approximate age']],
      rows: [{
        values: [{
          measurement: {
            size: '0-3 mths'
          }
        }, {
          measurement: {
            size: '16'
          }
        }, {
          measurement: {
            inch: '3.6-3.9',
            cm: '93-100'
          }
        }, {
          measurement: {
            size: '0-3 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-6 mths'
          }
        }, {
          measurement: {
            size: '17'
          }
        }, {
          measurement: {
            inch: '3.9-4.2',
            cm: '100-108'
          }
        }, {
          measurement: {
            size: '3-6 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6-9 mths'
          }
        }, {
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            inch: '4.2-4.5',
            cm: '108-116'
          }
        }, {
          measurement: {
            size: '6-9 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9-12 mths'
          }
        }, {
          measurement: {
            size: '19'
          }
        }, {
          measurement: {
            inch: '4.5-5.8',
            cm: '116-123'
          }
        }, {
          measurement: {
            size: '9-12 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12-18 mths/1-1.5 yrs'
          }
        }, {
          measurement: {
            size: '20'
          }
        }, {
          measurement: {
            inch: '4.8-5.1',
            cm: '123-130'
          }
        }, {
          measurement: {
            size: '12-18 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '18-24 mths/1.5-2 yrs'
          }
        }, {
          measurement: {
            size: '21/22'
          }
        }, {
          measurement: {
            inch: '5.1-5.4',
            cm: '130-138'
          }
        }, {
          measurement: {
            size: '18-24 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'infant 2'
          }
        }, {
          measurement: {
            size: '18'
          }
        }, {
          measurement: {
            inch: '4.2-4.5',
            cm: '108-116'
          }
        }, {
          measurement: {
            size: '6-12 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'infant 3'
          }
        }, {
          measurement: {
            size: '19'
          }
        }, {
          measurement: {
            inch: '4.5-5.8',
            cm: '116-123'
          }
        }, {
          measurement: {
            size: '6-12 mths'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'infant 4'
          }
        }, {
          measurement: {
            size: '20/21'
          }
        }, {
          measurement: {
            inch: '4.8-5.1',
            cm: '123-130'
          }
        }, {
          measurement: {
            size: '1-2 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'infant 5'
          }
        }, {
          measurement: {
            size: '22'
          }
        }, {
          measurement: {
            inch: '5.1-5.4',
            cm: '130-138'
          }
        }, {
          measurement: {
            size: '2-3 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'infant 6'
          }
        }, {
          measurement: {
            size: '23'
          }
        }, {
          measurement: {
            inch: '5.4-5.7',
            cm: '138-146'
          }
        }, {
          measurement: {
            size: '3-4 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '7'
          }
        }, {
          measurement: {
            size: '24'
          }
        }, {
          measurement: {
            inch: '5.7-6.0',
            cm: '146-153'
          }
        }, {
          measurement: {
            size: '3-4 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '8'
          }
        }, {
          measurement: {
            size: '25/26'
          }
        }, {
          measurement: {
            inch: '6-6.3',
            cm: '153-161'
          }
        }, {
          measurement: {
            size: '4-5 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '9'
          }
        }, {
          measurement: {
            size: '27'
          }
        }, {
          measurement: {
            inch: '6.3-6.6',
            cm: '161-169'
          }
        }, {
          measurement: {
            size: '4-5 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10'
          }
        }, {
          measurement: {
            size: '28'
          }
        }, {
          measurement: {
            inch: '6.6-6.9',
            cm: '169-176'
          }
        }, {
          measurement: {
            size: '5-6 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '11'
          }
        }, {
          measurement: {
            size: '29'
          }
        }, {
          measurement: {
            inch: '6.9-7.2',
            cm: '176-184'
          }
        }, {
          measurement: {
            size: '6-7 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '12'
          }
        }, {
          measurement: {
            size: '30/31'
          }
        }, {
          measurement: {
            inch: '7.3-7.6',
            cm: '184-192'
          }
        }, {
          measurement: {
            size: '6-7 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '13'
          }
        }, {
          measurement: {
            size: '32'
          }
        }, {
          measurement: {
            inch: '7.6-7.9',
            cm: '192-200'
          }
        }, {
          measurement: {
            size: '7-8 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '1'
          }
        }, {
          measurement: {
            size: '33'
          }
        }, {
          measurement: {
            inch: '7.9-8.2',
            cm: '200-209'
          }
        }, {
          measurement: {
            size: '8-9 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '2'
          }
        }, {
          measurement: {
            size: '34'
          }
        }, {
          measurement: {
            inch: '8.3-8.6',
            cm: '209-217'
          }
        }, {
          measurement: {
            size: '9-10 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3'
          }
        }, {
          measurement: {
            size: '36'
          }
        }, {
          measurement: {
            inch: '8.6-8.9',
            cm: '217-226'
          }
        }, {
          measurement: {
            size: '10-11 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '4'
          }
        }, {
          measurement: {
            size: '37'
          }
        }, {
          measurement: {
            inch: '8.9-9.2',
            cm: '226-234'
          }
        }, {
          measurement: {
            size: '10-12 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '5'
          }
        }, {
          measurement: {
            size: '38'
          }
        }, {
          measurement: {
            inch: '9.2-9.5',
            cm: '234-242'
          }
        }, {
          measurement: {
            size: '12-15 yrs'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6'
          }
        }, {
          measurement: {
            size: '39'
          }
        }, {
          measurement: {
            inch: '9.5-9.8',
            cm: '242-250'
          }
        }, {
          measurement: {
            size: '12-15 yrs'
          }
        }]
      }]
    }
  }, {
    title: 'Accessories',
    id: 'hats-and-headbands',
    data: {
      columns: [[{
        colSpan: 2,
        value: 'Hats & Headbands'
      }], ['Size', 'Circumference']],
      rows: [{
        values: [{
          measurement: {
            size: 'Newborn'
          }
        }, {
          measurement: {
            inch: '15',
            cm: '38'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: 'Up to 3mths'
          }
        }, {
          measurement: {
            inch: '16.5',
            cm: '42'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-6 mths'
          }
        }, {
          measurement: {
            inch: '17',
            cm: '44'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6-12 mths'
          }
        }, {
          measurement: {
            inch: '18.5',
            cm: '47'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '1-2 yrs'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '50'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-5 yrs'
          }
        }, {
          measurement: {
            inch: '20',
            cm: '52'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6-9 yrs'
          }
        }, {
          measurement: {
            inch: '21',
            cm: '54'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10-13 yrs'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '56'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14-16 yrs'
          }
        }, {
          measurement: {
            inch: '22',
            cm: '57'
          }
        }]
      }]
    }
  }, {
    title: '',
    id: 'scarves',
    unitToggle: false,
    data: {
      columns: [[{
        colSpan: 3,
        value: 'Scarves'
      }], ['Size', 'Length', 'Width']],
      rows: [{
        values: [{
          measurement: {
            size: '1-2 yrs'
          }
        }, {
          measurement: {
            inch: '35',
            cm: '90'
          }
        }, {
          measurement: {
            inch: '7',
            cm: '18'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '3-5 yrs'
          }
        }, {
          measurement: {
            inch: '39',
            cm: '100'
          }
        }, {
          measurement: {
            inch: '7',
            cm: '18'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '6-9 yrs'
          }
        }, {
          measurement: {
            inch: '43',
            cm: '110'
          }
        }, {
          measurement: {
            inch: '7',
            cm: '18'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '10-13 yrs'
          }
        }, {
          measurement: {
            inch: '47',
            cm: '120'
          }
        }, {
          measurement: {
            inch: '7',
            cm: '18'
          }
        }]
      }, {
        values: [{
          measurement: {
            size: '14-16 yrs'
          }
        }, {
          measurement: {
            inch: '51',
            cm: '130'
          }
        }, {
          measurement: {
            inch: '7',
            cm: '18'
          }
        }]
      }]
    }
  }],
  howToMeasure: {
    image: null,
    content: [{
      title: 'Foot Length',
      description: "Measure the child's foot while wearing socks, measure from the heel to the front edge of the longest toe."
    }]
  }
}];
/**
 * Get size guide content data
 * @param {string} name - Size guide name
 * @returns {Object} Content data
 */

export var getData = function getData(name) {
  return CATEGORY_DATA.find(function (data) {
    return data.category === name;
  });
};
/**
 * Calculate the number of table columns within a table row
 * corresponding to a category table data.
 * @param {Object[]} columns - Contains one or more arrays
 * @returns {number}
 */

export var calculateNumberOfColumns = function calculateNumberOfColumns(columns) {
  return columns.reduce(function (numberOfColumns, currentColumn) {
    var currentNumberOfColumns = currentColumn.reduce(function (count, currentCell) {
      var currentCount;

      if (_typeof(currentCell) === 'object' && currentCell.colSpan > 1) {
        currentCount = count + currentCell.colSpan;
        return currentCount;
      }

      currentCount = count + 1;
      return currentCount;
    }, 0);

    if (currentNumberOfColumns > numberOfColumns) {
      return currentNumberOfColumns;
    }

    return numberOfColumns;
  }, 0);
};
export default CATEGORY_DATA;